export default __webpack_public_path__ + "static/media/Curvet7.7.6552c5ff.svg";